import { Box } from '@mui/material';
import AttrLabel from '../Components/AttrLabel';
import AttrField from '../Fields/AttrField';
import ColorField from '../Fields/ColorField';
import PaddingFields from '../Fields/PaddingFields';
import { useTranslation } from 'react-i18next';

function TextPanel() {
    const { t } = useTranslation();

    return (
        <>
            <Box padding={3}>
                <AttrLabel>{t('Background Color')}</AttrLabel>
                <AttrField
                    Component={ColorField}
                    name="style.backgroundColor"
                    placeholder={t('Background Color')}
                    property="containerAttributes"
                />
                <AttrLabel>{t('Padding')}</AttrLabel>
                <PaddingFields
                    name="style.padding"
                    property="containerAttributes"
                />
            </Box>
        </>
    );
}

export default TextPanel;
